/*
 UploadFilesDialog component
 url match: / or /login
 Displays email id and password field
 with UploadFilesDialog button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../../Styles/dashboardStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FileDrop from 'react-file-drop';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import UploadedFilesComponent from './UploadedFilesComponent';

const acceptedFiles = ['image/png', 'image/jpeg', 'application/zip', 'application/pdf', 'application/x-zip-compressed']
@inject('dashboardStore', 'commonStore', 'userStore')
@observer
class UploadFilesDialog extends React.Component {
    state = {
        showUploadStatus: false
    }
    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
        this.zipInputFileRef = React.createRef()
    }

    closeDialog = () => {
        this.props.dashboardStore.closeUploadDialog();
        this.props.dashboardStore.resetFiles()
        this.setState({
            showUploadStatus: false
        })
    }

    openFileModal = (zip) => {
        if (zip)
            this.zipInputFileRef.current.click();
        else
            this.inputOpenFileRef.current.click();
    }
    handleDrop = (files, event) => {
        event.preventDefault();
        if (!files.length)
            return;
        if (!this.validateFiles(files)) {
            this.props.commonStore.handleOpenSnackBar("Only zip, PDF and image files are allowed!", "info");
            return;
        }
        this.props.dashboardStore.setUploadFiles(files)

        this.setState({
            showUploadStatus: true
        })
    }

    removeFile = (index) => {
        this.props.dashboardStore.removeFile(index)
    }

    uploadFiles = () => {
        if (this.props.dashboardStore.files.length > 10) {
            this.props.commonStore.handleOpenSnackBar("A maximum of 10 files is allowed for each upload!!", "info")
            return;
        }
        this.props.dashboardStore.uploadFiles(false)
            .then((response) => {
                if (!this.props.dashboardStore.uploadProgress && this.props.userStore.user.userType === 'SUPER_ADMIN')
                    this.props.history.push('/dashboard/aipending')

            })
    }

    validateFiles = (files) => {
        let temp = []
        temp = temp.concat(Array.from(files))
        let valid = true

        temp.forEach(file => {
            if (acceptedFiles.indexOf(file.type.toLowerCase()) < 0)
                valid = false
        })
        return valid
    }

    onChangeFile = (event, type) => {
        event.stopPropagation();
        event.preventDefault();
        var files = event.target.files;
        if (!files.length)
            return;
        if (!this.validateFiles(files)) {
            this.props.commonStore.handleOpenSnackBar("Only zip, PDF and image files are allowed!", "info");
            return;
        }
        this.props.dashboardStore.setUploadFiles(files);
        this.setState({
            showUploadStatus: true
        })
    }

    cancelUpload = () => {
        this.props.dashboardStore.cancelUpload();
    }

    render() {
        const { files, openUploadDialog, uploadProgress, uploadIcon, uploadedFolders } = this.props.dashboardStore;
        const { classes } = this.props;
        const { showUploadStatus } = this.state
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={openUploadDialog} onClose={this.closeDialog} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <div id="uploadDialog">
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ReactSVG style={{ cursor: 'pointer' }} src={Images.cancel} onClick={(e) => this.cancelUpload()} />
                        </div>
                        {uploadIcon == "close" ?
                            <div>
                                <div>
                                    <FileDrop onDrop={this.handleDrop}>
                                        <ReactSVG
                                            beforeInjection={svg => {
                                                svg.classList.add(classes.svg)
                                            }}
                                            src={Images.importDoc1} />
                                        <div style={{ color: 'white', textAlign: 'center', fontSize: '22px' }}>Drop Files Here</div>
                                    </FileDrop>
                                </div>

                                <div style={{ textAlign: 'center', color: 'gray' }}> or</div>
                                <div style={{ textAlign: 'center' }}>
                                    <Button variant="contained" className={classes.button} type="submit" onClick={(e) => this.openFileModal(false)} >
                                        Choose Files
                            <input multiple
                                            accept=".zip,.pdf,image/*"
                                            type="file"
                                            style={{ display: "none" }}
                                            ref={this.inputOpenFileRef}
                                            onChange={(e) => this.onChangeFile(e, false)}
                                        />
                                    </Button>
                                </div>
                                <div style={{ marginTop: '1vh', textAlign: 'center', color: 'white' }}>Alternately, you can upload files from your registered mail ID by sending them to vision+upload@amygb.ai </div>

                            </div> : null}
                        {showUploadStatus && (files.length || uploadedFolders.length) ?
                            <UploadedFilesComponent></UploadedFilesComponent> : null}
                        {showUploadStatus && files.length ? (!uploadProgress && uploadIcon === "close" ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10vh', justifyContent: 'center' }}>
                            <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px', marginRight: '1vw', backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.cancelUpload()}>
                                Cancel
                </Button>
                            <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.uploadFiles()}>
                                Upload
                </Button>
                        </div> : null) : null}

                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}
export default withStyles(dashboardStyles, { withTheme: true })(withRouter(UploadFilesDialog));
